module.exports = __webpack_public_path__ + "img/leakinstreet.53e8258e.svg";